import { Problem, ProblemDetectionContext, ProblemType, ProblemSeverity } from '../types';

export function detectFlowExecutionFailures(context: ProblemDetectionContext, generateId: () => string): Problem[] {
  const problems: Problem[] = [];
  const { logs } = context;

  // Look for execution failures
  const failureLogs = logs.filter(
    (log) => log.EventType === 'ExecutionResult' && log.LogData.Action?.ExecutionResult === 'Failed'
  );

  failureLogs.forEach((failureLog) => {
    const originalIndex = logs.indexOf(failureLog);
    problems.push({
      id: generateId(),
      type: ProblemType.FLOW_EXECUTION_FAILURE,
      severity: ProblemSeverity.HIGH,
      title: 'Flow Action Execution Failed',
      description: `Action "${failureLog.LogData.Action?.Type}" failed to execute`,
      timestamp: failureLog.AbsoluteTime,
      source: 'IVR_LOG',
      relatedData: { log: failureLog },
      suggestions: ['Check action configuration', 'Verify resource permissions', 'Review action parameters'],
      index: originalIndex >= 0 ? originalIndex : undefined
    });
  });

  return problems;
}
